import { ActionIcon } from "PFComponents/action_icon";
import { Flex } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Tooltip } from "PFComponents/tooltip";
import { IconName } from "PFTheme/graphics/icons";

import WarningTooltipContent from "./warning_tooltip_content";

interface WarningTooltipIconProps {
  label: string;
  counter: number;
  classes?: Record<string, string>;
  icon: IconName;
  height?: number;
  width?: number;
  iconColor: string;
  onClick?: VoidFunction;
  title?: string;
}

const WarningTooltipIcon = ({
  icon,
  label,
  counter,
  classes = {},
  iconColor,
  onClick,
  title
}: WarningTooltipIconProps) => (
  <Tooltip
    content={
      <WarningTooltipContent
        label={label}
        counter={counter}
        classes={{
          counter: classes.counter
        }}
        counterColor={iconColor}
      />
    }
  >
    {onClick ? (
      <ActionIcon onClick={onClick} size="sm" name={icon} fill={iconColor} title={title} />
    ) : (
      <Flex>
        <Icon name={icon} size="sm" fill={iconColor} />
      </Flex>
    )}
  </Tooltip>
);

export default WarningTooltipIcon;
